import React from 'react';
import { Heading, Table, TableColumnConfig, Text } from '@weave/design-system';
import { RegisteredService } from '@weave/schema-gen-ts/dist/schemas/organization/merge/coordinator/v1/api.pb';
import { listRegisteredServices } from './api';
import { useAlert } from '@weave/alert-system';
import { useQuery } from 'react-query';
import { theme } from '@weave/theme';

export const RegisteredServicesTab = () => {
  const alert = useAlert();

  const { data, isLoading } = useQuery(
    ['org-merge-registered-services'],
    listRegisteredServices,
    {
      onError: () => alert.error('Failed to load registered services'),
      refetchOnWindowFocus: false,
    }
  );

  const services = data?.services || [];

  const columnConfig: TableColumnConfig<RegisteredService>[] = [
    {
      Header: 'Service Name',
      accessor: 'serviceName',
      id: 'serviceName',
      cellRenderer: (value: string) => <Text>{value}</Text>,
    },
    {
      Header: 'Service ID',
      accessor: 'registeredServiceId',
      id: 'registeredServiceId',
      cellRenderer: (value: string) => <Text>{value}</Text>,
    },
    {
      Header: 'Address',
      accessor: 'address',
      id: 'address',
      cellRenderer: (value: string) => <Text>{value}</Text>,
    },
    {
      Header: 'Merge Wave',
      accessor: 'mergeWave',
      id: 'mergeWave',
      cellRenderer: (value: number) => <Text>{value}</Text>,
    },
    {
      Header: 'Asset Types',
      accessor: 'assetTypes',
      id: 'assetTypes',
      cellRenderer: (value: string[]) => <Text>{value?.join(', ') || 'N/A'}</Text>,
    },
  ];

  return (
    <div>
      <div
        style={{
          margin: `${theme.spacing(2)} 0`,
        }}
      >
        <Heading level={2}>Registered Services</Heading>
        <Text>
          These services have been registered with the org merge coordinator and can
          participate in org migrations.
        </Text>
      </div>
      <div>
        <Table
          data={services}
          colConfig={columnConfig}
          isLoading={isLoading}
          tableInstanceId="registered-services-table"
        />
      </div>
    </div>
  );
};
